<div id="map" class="map" #map>

 <!-- <div class="tools" id="toolsButtons">
        <mat-grid-list cols="1">
          <mat-grid-tile>
            <button mat-mini-fab class="buttonLayer" (click)="openWorkspace()">
              <mat-icon inline=true>layers</mat-icon>
            </button>
          </mat-grid-tile>
          <mat-grid-tile>
            <button mat-mini-fab class="buttonFilter" (click)="openFilter()">
              <mat-icon inline=true>search</mat-icon>
            </button>
          </mat-grid-tile>
        </mat-grid-list>
      </div> -->
      
    </div>
     <ng-template appDirectiveWidget></ng-template> 
     